import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
//serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

let width = window.innerWidth;
const enterkeyUpHandler = (e) => { 
  if(e.keyCode=== 13){
    const primaryButtonId = document.getElementById("primaryButtonId");
    const primaryButtonLoaderId = document.getElementById("primaryButtonLoaderId");
    if(primaryButtonId){
      primaryButtonId.click();
    }else if(primaryButtonLoaderId){
      primaryButtonLoaderId.click();
    }
  }
}
if(width > 768){
setTimeout(()=>{
  const el = document.getElementById("root");
  if(el){ 
    el.addEventListener("keyup", enterkeyUpHandler );
  }
},1000);}